export enum ActionType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  VIEW = 'VIEW',
  DELETE = 'DELETE',
}
